import Chip from '@mui/material/Chip';

import {formatProviderName} from '../../helpers/providers';
import {useGetProvidersQuery} from '../../redux/services/providerApi';
import ProviderAvatar from './ProviderAvatar';

const ProviderChip = ({ provider, providerId, ...props }) => {
  const query = useGetProvidersQuery({id: providerId}, {skip: !providerId});
  const _provider = provider || query?.data?.[0];
  return (
    <Chip
      color={props?.color}
      variant={props?.variant}
      label={query.isLoading ? 'Loading...' : formatProviderName(_provider)}
      avatar={<ProviderAvatar provider={_provider} sx={{height: 30, width: 30}}/>}
      onDelete={props.onDelete}
    >
    </Chip>
  );
};

export default ProviderChip;